import React from 'react';
import { QuestProvider } from '@questlabs/react-sdk';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import BeatBuddyApp from './components/BeatBuddyApp';
import NotFoundPage from './components/NotFoundPage';
import { LanguageProvider } from './contexts/LanguageContext';
import { ThemeProvider } from './contexts/ThemeContext';
import {
  AboutPage,
  PrivacyPage,
  TermsPage,
  HelpPage,
  ContactPage,
  FeaturesPage,
} from './components/ContentPages';
import '@questlabs/react-sdk/dist/style.css';
import './index.css';

function App() {
  return (
    <QuestProvider
      apiKey="k-e01b3f1e-f64b-45c7-9787-2e67a0b06f2c"
      entityId="e-77ff0494-cfb1-4dac-8c53-9fba1f53fc23"
      apiType="PRODUCTION"
    >
      <HelmetProvider>
        <ThemeProvider>
          <LanguageProvider>
            <Helmet>
              <html lang="zh-HK" />
              <link rel="canonical" href="https://beatbuddy.homy.hk/" />
            </Helmet>

            <Router>
              <Routes>
                <Route path="/" element={<BeatBuddyApp />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/help" element={<HelpPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/features" element={<FeaturesPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </Router>
          </LanguageProvider>
        </ThemeProvider>
      </HelmetProvider>
    </QuestProvider>
  );
}

export default App;